import { useAudioVideo } from '@providers/AudioVideoProvider';
import { DefaultModality } from 'amazon-chime-sdk-js';
import { useEffect, useState } from 'react';

const useVolumeIndicator = (attendeeId: string) => {
  const [volume, setVolume] = useState(0);
  const audioVideo = useAudioVideo();

  useEffect(() => {
    if (!audioVideo) {
      return;
    }

    const callback = (attendeeId: string, volume: number | null) => {
      const baseAttendeeId = new DefaultModality(attendeeId).base();
      if (baseAttendeeId !== attendeeId) {
        // Optional: Do not include the content attendee (attendee-id#content) in the roster.
        // See the "Screen and content share" section for details.
        return;
      }

      setVolume(volume ?? 0); // a fraction between 0 and 1
    };

    audioVideo.realtimeSubscribeToVolumeIndicator(attendeeId, callback);

    return () =>
      audioVideo.realtimeUnsubscribeFromVolumeIndicator(attendeeId, callback);
  }, [audioVideo, attendeeId]);

  return volume;
};

export default useVolumeIndicator;
